import authenticated from "../middleware/authenticated";
import DefaultRouterView from "../../views/DefaultRouterView";
import authorized from "../middleware/authorized";

export default [
    {
        path: '/admin',
        meta: {
            middleware: [authenticated, authorized],
            roles: ['ROLE_ADMIN'],
        },
        component: () => import(/* webpackChunkName: "adminLayout" */ '../../views/admin/Layout.vue'),
        children: [
            {
                path: '',
                name: 'Admin',
                component: () => import(/* webpackChunkName: "Admin" */ '../../views/admin/Index.vue'),
            },

            {
                path: 'applications/statuses',
                component: DefaultRouterView,
                children: [
                    {
                        path: '',
                        name: 'AdminApplicationStatusesList',
                        component: () => import(/* webpackChunkName: "AdminApplicationStatusesList" */ '../../views/admin/application-statuses/List.vue'),
                    },
                ]
            },

            {
                path: 'section/types',
                component: DefaultRouterView,
                children: [
                    {
                        path: '',
                        name: 'AdminSectionTypesList',
                        component: () => import(/* webpackChunkName: "AdminSectionTypesList" */ '../../views/admin/section-types/List.vue'),
                    },
                ]
            },

            {
                path: 'section/documents',
                component: DefaultRouterView,
                children: [
                    {
                        path: '',
                        name: 'AdminSectionDocumentsList',
                        component: () => import(/* webpackChunkName: "AdminSectionDocumentsList" */ '../../views/admin/section-documents/List.vue'),
                    },
                ]
            },

            {
                path: 'calculator/expert-purpose/categories',
                component: DefaultRouterView,
                children: [
                    {
                        path: '',
                        name: 'AdminExpertPurposeCategoriesList',
                        component: () => import(/* webpackChunkName: "AdminExpertPurposeCategoriesList" */ '../../views/admin/expert-purpose-categories/List.vue'),
                    },
                ]
            },

            {
                path: 'calculator/purpose-types',
                component: DefaultRouterView,
                children: [
                    {
                        path: '',
                        name: 'AdminPurposeTypesList',
                        component: () => import(/* webpackChunkName: "AdminPurposeTypesList" */ '../../views/admin/purpose-types/List.vue'),
                    },
                ]
            },

            {
                path: 'refs/additional-expertises',
                component: DefaultRouterView,
                children: [
                    {
                        path: '',
                        name: 'AdminAdditionalExpertisesList',
                        component: () => import(/* webpackChunkName: "AdminAdditionalExpertisesList" */ '../../views/admin/additional-expertises/List.vue'),
                    },
                ]
            },
            {
                path: 'refs/appointments',
                component: DefaultRouterView,
                children: [
                    {
                        path: '',
                        name: 'AdminAppointmentsList',
                        component: () => import(/* webpackChunkName: "AdminAppointmentsList" */ '../../views/admin/appointments/List.vue'),
                    },
                ]
            },
            {
                path: 'refs/construction-types',
                component: DefaultRouterView,
                children: [
                    {
                        path: '',
                        name: 'AdminConstructionTypesList',
                        component: () => import(/* webpackChunkName: "AdminConstructionTypesList" */ '../../views/admin/construction-types/List.vue'),
                    },
                ]
            },
            {
                path: 'refs/expert-types',
                component: DefaultRouterView,
                children: [
                    {
                        path: '',
                        name: 'AdminExpertTypesList',
                        component: () => import(/* webpackChunkName: "AdminExpertTypesList" */ '../../views/admin/expert-types/List.vue'),
                    },
                ]
            },
            {
                path: 'refs/contract-subjects',
                component: DefaultRouterView,
                children: [
                    {
                        path: '',
                        name: 'AdminContractSubjectsList',
                        component: () => import(/* webpackChunkName: "AdminContractSubjectsList" */ '../../views/admin/contract-subjects/List.vue'),
                    },
                ]
            },
            {
                path: 'refs/expert-object-types',
                component: DefaultRouterView,
                children: [
                    {
                        path: '',
                        name: 'AdminExpertObjectTypesList',
                        component: () => import(/* webpackChunkName: "AdminExpertObjectTypesList" */ '../../views/admin/expert-object-types/List.vue'),
                    },
                ]
            },
            {
                path: 'refs/location-categories',
                component: DefaultRouterView,
                children: [
                    {
                        path: '',
                        name: 'AdminLocationCategoriesList',
                        component: () => import(/* webpackChunkName: "AdminLocationCategoriesList" */ '../../views/admin/location-categories/List.vue'),
                    },
                ]
            },
            {
                path: 'refs/location-types',
                component: DefaultRouterView,
                children: [
                    {
                        path: '',
                        name: 'AdminLocationTypesList',
                        component: () => import(/* webpackChunkName: "AdminLocationTypesList" */ '../../views/admin/location-types/List.vue'),
                    },
                ]
            },
            {
                path: 'refs/payment-types',
                component: DefaultRouterView,
                children: [
                    {
                        path: '',
                        name: 'AdminPaymentTypesList',
                        component: () => import(/* webpackChunkName: "AdminPaymentTypesList" */ '../../views/admin/payment-types/List.vue'),
                    },
                ]
            },

            {
                path: 'route-statuses/applications',
                component: DefaultRouterView,
                children: [
                    {
                        path: '',
                        name: 'AdminApplicationRoutesList',
                        meta: {
                            sidebar: 'slidable',
                        },
                        component: () => import(/* webpackChunkName: "AdminApplicationRoutesList" */ '../../views/admin/application-routes/List.vue'),
                    },
                ]
            },

            {
                path: 'route-statuses/resolutions',
                component: DefaultRouterView,
                children: [
                    {
                        path: '',
                        name: 'AdminResolutionRoutesList',
                        meta: {
                            sidebar: 'slidable',
                        },
                        component: () => import(/* webpackChunkName: "AdminResolutionRoutesList" */ '../../views/admin/resolution-routes/List.vue'),
                    },
                ]
            },
        ]
    },
];
